import logo from './logo.svg';
import './App.css';
import { Product } from './pages/Product';
import { ErrorPage } from './pages/ErrorPage';
import { Home } from './pages/Home';
import { ContentProvider } from './context'; //AuthContext, 
import Root from "./components/Layout/Root";

import { createBrowserRouter,
          RouterProvider,
          redirect,
          useLocation } from "react-router-dom";

function App() {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Root />,
      errorElement: <ErrorPage />,
      children: [
        {
            path: "/",
            //loader: protectedLoader,
            element: <Home />,
        },
        {
            path: "/:slug",
            //loader: protectedLoader,
            element: <Home />,
        },
        {
            path: "productos/:producto",
            //loader: protectedLoader,
            element: <Home />,//Product
        },
      ]
    },
  ]);

  return (
    <ContentProvider>
      <RouterProvider router={router} />
    </ContentProvider>
  );
}

export default App;
